export default "__VITE_ASSET__921edef4__"